import React from "react";
import classNames from "classnames";

interface StatisticProps {
  count: number
  label: string
  color?: "darkgray" | "purple" | "orange" | "red" | "blue" | "green"
  onClick?: () => void
}

const StatisticsDiv = (props: StatisticProps) => {
  const { count, label, color, onClick } = props;

  const countClasses = classNames("count", color);
  const lineClasses = classNames("line", `${color}-bg`);

  return <div
    className="statistic"
    onClick={onClick}
  >
    <div className="label">{label}</div>
    <span className={countClasses}>{count}</span>
    {props.color && <div className={lineClasses} />}
  </div >;
};

export default StatisticsDiv;